import React from "react";
import DonorGemIcon from "../icons/DonorGemIcon";
import {
  donorGemFadeClass,
  formatDonorGemLabel,
  formatDonorGemTooltip,
  resolveDonorGemColorVariant,
} from "../../utils/donorGemDisplay";

export default function DonorGemBadge({
  donorGem = null,
  showLabel = false,
  className = "",
  onClick = null,
}) {
  if (!donorGem?.showBadge) return null;

  const colorVariant = resolveDonorGemColorVariant(donorGem);
  const donorText = formatDonorGemTooltip(donorGem);
  const isClickable = typeof onClick === "function";
  const isInactive = !donorGem.isActive;

  const wrapClassName = [
    "donor-gem-badge__wrap",
    colorVariant ? `donor-gem-badge__wrap--${colorVariant}` : "",
    isInactive ? "donor-gem-badge__wrap--inactive" : "",
    isClickable ? "donor-gem-badge__wrap--clickable" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const gem = (
    <>
      <DonorGemIcon
        className={[
          "donor-gem-badge__gem",
          colorVariant ? `donor-gem-badge__gem--${colorVariant}` : "",
          isInactive ? "donor-gem-badge__gem--inactive" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        outline={isInactive}
      />
      <span className="donor-gem-badge__tooltip" role="tooltip">
        {donorText}
      </span>
    </>
  );

  return (
    <div
      className={[
        "donor-gem-badge",
        donorGemFadeClass(donorGem),
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {isClickable ? (
        <button
          type="button"
          className={wrapClassName}
          onClick={(e) => {
            e.stopPropagation();
            onClick(e);
          }}
          aria-label={donorText}
          data-resource="public.donation-panel"
          data-action="execute"
          data-route="/api/public/donate-panel"
          data-description="Open donation panel from donor gem"
        >
          {gem}
        </button>
      ) : (
        <span className={wrapClassName}>{gem}</span>
      )}
      {showLabel ? (
        <span className="donor-gem-badge__label">{formatDonorGemLabel(donorGem)}</span>
      ) : null}
    </div>
  );
}
